import { Component, OnInit } from '@angular/core';
import { HttpserviceService } from '../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../service/utils.service';
import { GlobalConfig } from '../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs/Subject';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css']
})
export class LogsComponent implements OnInit {
  agentId: any = '';
  isList: Boolean = true;
  constructor(
    private servicesComponent: HttpserviceService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager,
    private route: ActivatedRoute,
    private modalService: BsModalService,
  ) {
    this.agentId = route.snapshot.params['id'];
  }
  bsModalRef: BsModalRef;
  totalItems: any = Number;
  logs: any[] = [];
  packagesIds: any[] = [];
  checkAll: Boolean = false;
  page: any = { pageNumber: 1, pageSize: 20, agentId: 0 };
  ngOnInit() {
    if (this.agentId > 0) { 
      this.page.agentId = this.agentId;
    }
    this.getLogsAsync();
  }

  getLogsAsync() {
    this.servicesComponent.getLogAsync(this.page)
      .then((response: any) => {
        if (response.success) {
          this.logs = response.receiveObj.result.data;
          this.totalItems = response.receiveObj.result.total_rows;
          this.isList = this.logs.length > 0 ? true : false;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  pageChanged(event: any): void {
    this.page.pageNumber = event.page;
    this.page.pageSize = event.itemsPerPage;
    this.getLogsAsync();
  }

  searchState() {
    this.page.pageNumber = 1;
    this.getLogsAsync();
  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/logs/logs.component.ts